<template>
  <div>
    <apps-list :apps="$store.state.ClientAppStore.apps"></apps-list>
  </div>
</template>

<script>
import AppsList from '../components/RecordLists/AppsList'

export default {
  components: {
    AppsList
  },
  data() {
    return {
      name: 'Default App Name'
    }
  },
  created: function() {
    this.$store.dispatch('ClientAppStore/fetchClientApps')
  },
  methods: {}
}
</script>

<style scoped></style>
